import React from "react";
import { Card, Grid, Box,CardContent } from "@mui/material";

const VideoGallery = () => {
  const videos = [
    "pa5hgl2XYzU",
    "MvBwf0oOMZo",
    "msroSR1Nno4"
   
  ];


  return (
    <div style={{ padding: "16px", margin: "auto" }}>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>Video Gallery</h1>
      <Grid container spacing={2}>
        {videos.map((videoId, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Card>
              <CardContent style={{ display: "flex", justifyContent: "center" }}>
                <iframe
                  width="100%"
                  height="300"
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default VideoGallery;
